import { NotifierService } from '@app/shared/services/notifier.service';
import { Logger } from '@app/core';
import { ManageFunctionComponent } from './../manage-function/manage-function.component';
import { FlowOrigin } from './../shared/storage.service';
import { ManageTaskService } from './../shared/manage-task.service';
import {
  Tarea,
  TipoAsociacion,
  ConfirmComponent,
  TareaAsociacionPred,
  Documento,
  DocumentoAsociadoGrupo,
  DocumentoAsociarTarea,
  TypeProcess,
  TareaAsociacion,
  FuncionDocumento
} from '@app/shared';
import {
  Component,
  OnInit,
  AfterViewInit,
  OnDestroy,
  Input,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter
} from '@angular/core';
import { ManageAssociationDataService } from './shared/manage-association.data.service';
import { generate } from 'shortid';
import { Subscription } from 'rxjs/Subscription';
import { find, result, findIndex, filter } from 'lodash';
import {
  FormGroup,
  FormControl,
  Validators
} from '@angular/forms';
import {
  BsModalRef,
  BsModalService
} from 'ngx-bootstrap/modal';
import { LocalDataSource } from 'ng2-smart-table';
import { ManageAssociationConfigService } from './shared/manage-association.config.service';
import { Subject } from 'rxjs';

const log: Logger = new Logger('ManageAssociationComponent');

export interface TareaAsociation {
  id: number[];
  task: Tarea[];
  documentos_asociados: Array<DocumentoAsociadoGrupo>;
  typeAsociation?: string;
  alias?: string;
}

export interface NotifyAssociation {
  id: string;
  targetTask?: Array<Tarea>;
}

export interface DocumentTable {
  clasificacion: string;
  tipo_documental: string;
  clasificacion_id: number;
}

export interface GroupTaskAsociation {
  alias: string;
  asociation: TareaAsociation[];
}

@Component({
  selector: 'iw-manage-association',
  templateUrl: './manage-association.component.html',
  styleUrls: ['./manage-association.component.scss'],
  providers: [ManageAssociationDataService, ManageTaskService]
})
export class ManageAssociationComponent implements OnInit, AfterViewInit, OnDestroy {
  // Contiene el tipo de proceso que se esta renderizando
  @Input() typeProcess: TypeProcess;
  // Tarea actual, con la que se esta trabajando (origen)
  @Input() sourceTask: Tarea;
  // Origen del flujo
  @Input() origin: FlowOrigin;
  // Tarea elegida en el flujo
  targetTask: Array<Tarea> = [];
  // Index de la asociacion seleccionada
  taskSelectIndex: number;
  // Tareas asociadas
  taskAsociation: Array<TareaAsociation> = [];
  // Tareas asociadas
  typesAsociations: Array<TipoAsociacion> = [];
  // Configuracion de la tabla
  settings = {};
  // Contiene los documentos
  source: Documento[] = [];
  // Documento asociado seleccionado
  documentSelectFunction: DocumentoAsociarTarea;
  // Contiene los datos de la tabla previamente seteados y listos para renderizar en la tabla
  sourceData: LocalDataSource;
  // Controla si se muestra las tareas asociadas
  showTargetTask = false;
  // formulario para validar lo ingresado en el campo de alias de la asociacion
  formA: FormGroup = new FormGroup({
    alias: new FormControl('', [Validators.pattern('^[a-zA-Z_]*$')])
  });
  // Identificador único para la comunicación con el flujo
  private id: string = generate();
  // Contiene el index donde se agregara la tarea seleccionada
  private idDeleteT = 0;
  // Id de la tarea que se desea eliminar de las asociaciones
  private indexGroupAsociationSelect = -1;
  // Referencia de la modal
  private modalRef: BsModalRef;
  // Suscripción a las notificaciones otros componentes
  private notifications: Subscription;
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();
  // Referencia al componente de confirmación
  @ViewChild('confirmAction') private confirmAction: ConfirmComponent;
  // Referencia al componente de el modal de acciones de la tabla
  @ViewChild('modalTable') private modalTable: ManageFunctionComponent;
  // Referencia al componente de el modal de acciones de la tabla
  @ViewChild('modalTableDocuments') private modalTableDocuments: TemplateRef<any>;
  // Emite la lista de alias configurado para las asociaciones
  @Output() listAliasAsocciations = new EventEmitter<Array<{alias: string}>>();

  constructor(
    private ns: NotifierService,
    private mads: ManageAssociationDataService,
    private mts: ManageTaskService,
    private modalService: BsModalService,
  ) { }

  ngOnInit() {
    this.mads.getTypesAssociations().subscribe(asocciations => {
      this.typesAsociations = asocciations;
      this.loadingTaskAssociations();
    });
    const docsC = new ManageAssociationConfigService();
      docsC.tableMultipleTask();
    this.settings = docsC.settings;
    docsC.accion.subscribe((data: any) => {
      this.actionTable(data);
    });
  }

  ngAfterViewInit(): void {
    this.notifications = this.ns
      .get()
      .filter((n) => {
        return n.source === 'processAutomation' && n.action === 'setTaskTarget' && n.instance === this.typeProcess;
      })
      .subscribe(n => {
        const data = <NotifyAssociation>n.data;
        if (this.id === data.id) {
          this.targetTask = data.targetTask;
          this.showTargetTask = true;
          this.loadingTaskAsociation();
        }
      });
  }

  ngOnDestroy(): void {
    this.notifications.unsubscribe();
    this.destroy.next();
    this.destroy.complete();
  }

  /**
   * Carga las tareas asociadas
   *
   * @memberof ManageAssociationComponent
   */
  async loadingTaskAssociations() {
    this.targetTask = await this.mts.getAsociationTask(this.sourceTask, this.origin, true);
    this.loadingTaskAsociation();
  }

  /**
   * Notifica que se desea seleccionar una tarea para la asociacion
   *
   * @param {number} [indexAsociation]
   * @memberof ManageAssociationComponent
   */
  activeAsociationMode(indexAsociation?: number) {
    if (indexAsociation !== undefined) {
      this.indexGroupAsociationSelect = indexAsociation;
    } else {
      this.indexGroupAsociationSelect = -1;
    }
    this.ns.set({
      source: 'manageAssociation',
      eventTriggered: 'click',
      action: 'activeAssociationMode',
      instance: this.typeProcess,
      data: <NotifyAssociation>{
        id: this.id,
        targetTask: this.targetTask
      }
    });
  }

  /**
   * Carga las tareas asociadas para mostrarlas visualmente
   *
   * @memberof ManageAssociationComponent
   */
  loadingTaskAsociation() {
    if (this.targetTask) {
      this.targetTask.forEach(task => {
        let tipoAsociation = null;
        let alias = null;
        const documentAssociation: DocumentoAsociadoGrupo[] = [];
        if (this.sourceTask) {
          let taskA: TareaAsociacion;
          if (result(task, 'id')) {
            taskA = find(this.sourceTask.tarea_asociacion, {id_tarea_destino: task.id});
          } else {
            taskA = find(this.sourceTask.tarea_asociacion, {id_tarea_destino: task['id_tarea_destino']});
          }
          if (taskA) {
            let tmpDocAsso: any = [];
            tipoAsociation = taskA.tipo_asociacion;
            alias = taskA.alias;
            tmpDocAsso = taskA.documentos_asociados;
            if (!taskA.documentos_asociados) {
              tmpDocAsso = taskA.documentos;
            }
            if (tmpDocAsso && tmpDocAsso.length) {
              tmpDocAsso.forEach((doc: any, index: number) => {
                documentAssociation.push({
                  id_documento: doc['id_documento'],
                  funciones: [],
                  id_tarea: taskA.id_tarea_destino
                });
                if (doc['funciones'] && doc['funciones'].length) {
                  doc['funciones'].forEach((funcion: any) => {
                    documentAssociation[index].funciones.push({
                      funcion: funcion.funcion,
                      id_funcion: funcion.id_funcion,
                      obligatorio: funcion.obligatorio
                    });
                  });
                }
              });
            }
          }
        }
        let taskExist;
        if (task.id) {
          taskExist = find(this.taskAsociation, taskA => taskA.id.indexOf(task.id) !== -1);
        } else {
          taskExist = find(this.taskAsociation, taskA => taskA.id.indexOf(task['id_tarea_destino']) !== -1);
        }
        if (!taskExist) {
          if (this.indexGroupAsociationSelect === -1) {
            let indexGroup = -1;
            indexGroup = findIndex(this.taskAsociation, {alias: alias});
            if (indexGroup === -1) {
              if (task.id) {
                this.taskAsociation.push({
                  id: [task.id],
                  task: [task],
                  documentos_asociados: documentAssociation,
                  typeAsociation: tipoAsociation ? tipoAsociation : this.typesAsociations[0].nombre,
                  alias: alias,
                });
              } else {
                this.taskAsociation.push({
                  id: [task['id_tarea_destino']],
                  task: [task],
                  typeAsociation: tipoAsociation ? tipoAsociation : this.typesAsociations[0].nombre,
                  alias: alias,
                  documentos_asociados: documentAssociation,
                });
              }
            } else {
              this.taskAsociation[indexGroup].task.push(task);
              this.taskAsociation[indexGroup].id.push(task.id);
              if (documentAssociation && documentAssociation.length) {
                documentAssociation.forEach(document => {
                  this.taskAsociation[indexGroup].documentos_asociados.push(document);
                });
              }
            }
          } else {
            this.taskAsociation[this.indexGroupAsociationSelect].id.push(task.id);
            this.taskAsociation[this.indexGroupAsociationSelect].task.push(task);
            this.indexGroupAsociationSelect = -1;
          }
        }
      });
      this.emitAssociationsConfigAlias();
    }
  }

  /**
   * Encargado de abrir la modal de confirmacion cuando se desea eliminar una tarea asociada
   *
   * @param {number} filterDelete
   * @param {('deleteGroupAsociation' | 'deleteTaskAsociation')} [action='deleteGroupAsociation']
   * @memberof ManageAssociationComponent
   */
  confirm(filterDelete: number, action: 'deleteGroupAsociation' | 'deleteTaskAsociation' = 'deleteGroupAsociation') {
    switch (action) {
      case 'deleteTaskAsociation':
        this.confirmAction.new({
          question: '¿Desea eliminar la tarea asociada?',
          labelConfirm: 'Sí',
          labelDecline: 'No'
        }).then(resp => {
          if (resp) {
            const indexTaskA = findIndex(this.taskAsociation, (task) => task.id.indexOf(filterDelete) !== -1);
            if (indexTaskA !== undefined && indexTaskA !== -1) {
              const documents = filter(
                this.taskAsociation[indexTaskA].documentos_asociados,
                document => document.id_tarea !== filterDelete
              );
              this.taskAsociation[indexTaskA].documentos_asociados = documents;
              const indexId = this.taskAsociation[indexTaskA].id.indexOf(filterDelete);
              const indexTask = findIndex(this.taskAsociation[indexTaskA].task, {id: filterDelete});
              const tTaskIndex = findIndex(this.targetTask, {id: filterDelete});
              const docTaskAssociation = filter(
                this.taskAsociation[indexTaskA].documentos_asociados,
                {id_tarea: filterDelete}
              );
              if (indexId !== -1) {
                this.taskAsociation[indexTaskA].id.splice(indexId, 1);
              }
              if (indexTask !== -1) {
                this.taskAsociation[indexTaskA].task.splice(indexTask, 1);
              }
              if (tTaskIndex !== -1) {
                this.targetTask.splice(tTaskIndex, 1);
              }
              if (docTaskAssociation && docTaskAssociation.length) {
                docTaskAssociation.forEach(doc => {
                  const docIndex = findIndex(
                    this.taskAsociation[indexTaskA].documentos_asociados,
                    {id_tarea: doc.id_tarea, id_documento: doc.id_documento}
                  );
                  if (docIndex !== -1) {
                    this.taskAsociation[indexTaskA].documentos_asociados.splice(docIndex, 1);
                  }
                });
              }
            }
          }
        });
        break;
      default:
        this.confirmAction.new({
          question: '¿Desea eliminar el grupo de tareas asociadas?',
          labelConfirm: 'Sí',
          labelDecline: 'No'
        }).then(resp => {
          if (resp) {
            this.taskAsociation.splice(filterDelete, 1);
          }
        });
        break;
    }
  }

  /**
   * Elimina la tarea asociada seleccionada
   *
   * @param {number} idTask
   * @memberof ManageAssociationComponent
   */
  deleteAssociation(res: boolean) {
    if (res) {
      if (this.idDeleteT !== 0) {
        for (let index = 0; index < this.targetTask.length; index++) {
          if (this.targetTask[index].id === this.idDeleteT) {
            this.targetTask.splice(index, 1);
          }
        }
        const indexTaskA = findIndex(this.taskAsociation, (task) => task.id.indexOf(this.idDeleteT) !== -1);
        if (indexTaskA && indexTaskA !== -1) {
          this.taskAsociation.splice(indexTaskA, 1);
        }
        this.idDeleteT = 0;
      }
      this.loadingTaskAsociation();
    }
  }

  /**
   * Setea el tipo de asociacion de la tarea
   *
   * @param {*} data
   * @param {number} idTask
   * @memberof ManageAssociationComponent
   */
  setTypeAssocition(data: any, idTask: number) {
    let asociationR = find(this.taskAsociation,{id:idTask});
    if(asociationR){
      asociationR.typeAsociation = data.target.value;
    }
  }

  /**
   * Setea el alias de la tarea
   *
   * @param {*} data
   * @param {number} idTask
   * @memberof ManageAssociationComponent
   */
  setAliasAssocition(data: any, indexAsociation: number) {
    this.taskAsociation[indexAsociation].alias = data.target.value;
    this.emitAssociationsConfigAlias();
  }

  /**
   * Retorna la lista de tareas asociadas
   *
   * @returns {(Array<TareaAsociacionPred> | 'tipo' | 'alias')}
   * @memberof ManageAssociationComponent
   */
  getAsocciations(): Array<TareaAsociacionPred> | 'tipo' | 'alias' | 'duplicacion' {
    const associations: Array<TareaAsociacionPred> = [];
    let validType = true;
    let validAlias = true;
    const formTemporal: FormGroup = new FormGroup({
      alias: new FormControl('', [Validators.pattern('^[a-zA-Z_]*$')])
    });
    for (const association of this.taskAsociation) {
      if (association.typeAsociation) {
        formTemporal.controls['alias'].setValue(association.alias);
        if (formTemporal.controls['alias'].valid) {
          const alias = find(associations, {alias: association.alias});
          if (alias) {
            if (association.id.indexOf(alias.id_tarea_destino) === -1) {
              return 'duplicacion';
            }
          }
          const typeA = find(this.typesAsociations, { nombre: association.typeAsociation });
          association.id.forEach(id => {
            associations.push({
              id_tarea_inicio: this.sourceTask ? this.sourceTask.id : 0,
              id_tarea_destino: id,
              id_tipo_asociacion: typeA.id,
              tipo_asociacion: typeA.nombre,
              task: association.task ? this.formatTaskAsociation(find(association.task, {id: id})) : null,
              alias: association.alias,
              proceso_externo: association.task ?
                                result(find(association.task, {id: id}), 'proceso_externo') ? true : false
                               : null,
              documentos: filter(association.documentos_asociados, {id_tarea: id})
            });
          });
        } else {
          validAlias = false;
          break;
        }
      } else {
        validType = false;
        break;
      }
    }
    if (validType) {
      if (validAlias) {
        return associations;
      } else {
        return 'alias';
      }
    }
    return 'tipo';
  }

  /**
   * Limpiar componente
   *
   * @memberof ManageAssociationComponent
   */
  empty() {
    this.taskAsociation = [];
    delete this.sourceTask;
    this.targetTask = [];
  }

  /**
   * Abre el modal de asociacion de documentos
   *
   * @param {Documento[]} document
   * @param {DocumentoAsociado[]} documentAssociation
   * @param {Tarea} task
   * @memberof ManageAssociationComponent
   */
  openAsociationDocument(indexAssociation: number, tasks: TareaAsociation) {
    this.modalRef = this.modalService.show(
      this.modalTableDocuments,
      {class: 'modal-lg-personalized', backdrop: 'static'}
    );
    this.source = [];
    this.taskSelectIndex = indexAssociation;
    tasks.task.forEach(task => {
      task.documentos.forEach(doc => {
        let tmpDoc: Documento;
        tmpDoc = {
          clasificacion_id: doc.clasificacion_id,
          clasificacion: doc.clasificacion,
          documento: doc.documento,
          codigo_documento: doc.codigo_documento,
          documentos_detalle: doc.documentos_detalle,
          id_tipo_documental: doc.id_tipo_documental,
          ruta_generacion: doc.ruta_generacion,
          ruta_vista_previa: doc.ruta_vista_previa,
          tipo_documental: doc.tipo_documental,
          funciones: [],
        };
        tmpDoc['associate'] = 'No';
          tmpDoc['tramite'] = task['tramite'];
          tmpDoc['tarea'] = task.nombre;
        tmpDoc['tarea_id'] = task.id;
        const docA = find(tasks.documentos_asociados, {id_documento: doc.documento, id_tarea: task.id});
        if (docA) {
          tmpDoc['associate'] = 'Si';
        }
        this.source.push(tmpDoc);
      });
    });
    this.sourceData = new LocalDataSource(this.source);
    this.sourceData.refresh();
  }

  /**
   * Cierra la modal de asociaciones de documentos
   *
   * @memberof ManageAssociationComponent
   */
  close() {
    this.modalRef.hide();
    this.taskSelectIndex = null;
  }

  /**
   * Controla las acciones en la tabla de asociacion de documentos
   *
   * @param {*} data
   * @memberof ManageAssociationComponent
   */
  async actionTable(data: any) {
    switch (data.action) {
      case 'asociar':
        this.source.forEach(item => {
          if (item.documento === data.row.documento && item['tarea_id'] === data.row.tarea_id) {
            item['associate'] = 'Si';
          }
        });
        this.sourceData = new LocalDataSource(this.source);
        this.sourceData.refresh();
        if (this.taskAsociation[this.taskSelectIndex]) {
          if (!this.taskAsociation[this.taskSelectIndex].documentos_asociados.length) {
            this.taskAsociation[this.taskSelectIndex].documentos_asociados.push({
              id_documento: data.row.documento,
              funciones: [],
              id_tarea: data.row.tarea_id
            });
          } else {
            const existDoc = find(
              this.taskAsociation[this.taskSelectIndex].documentos_asociados,
              {id_documento: data.row.clasificacion_id, id_tarea: data.row.tarea_id}
            );
            if (!existDoc) {
              this.taskAsociation[this.taskSelectIndex].documentos_asociados.push({
                id_documento: data.row.documento,
                funciones: [],
                id_tarea: data.row.tarea_id
              });
            }
          }
        }
        break;
      case 'eliminar':
        this.source.forEach(item => {
          if (item.documento === data.row.documento && item['tarea_id'] === data.row.tarea_id) {
            item['associate'] = 'No';
          }
        });
        this.sourceData = new LocalDataSource(this.source);
        this.sourceData.refresh();
        if (this.taskAsociation[this.taskSelectIndex]) {
          const indexDocument = findIndex(
            this.taskAsociation[this.taskSelectIndex].documentos_asociados,
            {id_documento: data.row.documento, id_tarea: data.row.tarea_id}
          );
          if (indexDocument !== -1) {
            this.taskAsociation[this.taskSelectIndex].documentos_asociados.splice(indexDocument, 1);
          }
        }
        break;
      case 'funciones':
          if (this.taskAsociation[this.taskSelectIndex]) {
            if (
              this.taskAsociation[this.taskSelectIndex].documentos_asociados &&
              this.taskAsociation[this.taskSelectIndex].documentos_asociados.length
            ) {
              const docAssociation = find(
                this.taskAsociation[this.taskSelectIndex].documentos_asociados,
                {id_documento: data.row.documento, id_tarea: data.row.tarea_id}
              );
              if (docAssociation) {
                const functions: FuncionDocumento[] = [];
                docAssociation.funciones.forEach(functionDoc => {
                  functions.push({
                    id_funcion: functionDoc.id_funcion,
                    funcion: functionDoc.funcion,
                    obligatorio: functionDoc.obligatorio
                  });
                });
                this.documentSelectFunction = {
                  documento: docAssociation.id_documento,
                  funciones: functions
                };
                this.modalTable.document = this.documentSelectFunction;
              }
            }
          }
        this.modalTable.open();
        break;
    }
  }

  /**
   * Guarda las funciones agregadas al documento asociado
   *
   * @param {DocumentoAsociarTarea} funtionsDocument
   * @memberof ManageAssociationComponent
   */
  saveFuntion(funtionsDocument: DocumentoAsociarTarea) {
    if (this.taskAsociation[this.taskSelectIndex]) {
      if (
        this.taskAsociation[this.taskSelectIndex].documentos_asociados &&
        this.taskAsociation[this.taskSelectIndex].documentos_asociados.length
      ) {
        this.taskAsociation[this.taskSelectIndex].documentos_asociados.forEach(docAssociation => {
          if (docAssociation.id_documento === funtionsDocument.documento) {
            docAssociation.funciones = funtionsDocument.funciones ? funtionsDocument.funciones : [];
          }
        });
      }
    }
  }

  /**
   * Emite una lista de objetos con los alias de las asociaciones configuradas
   *
   * @private
   * @memberof ManageAssociationComponent
   */
  private emitAssociationsConfigAlias() {
    const associations: Array<{alias: string}> = [];
    if (this.taskAsociation && this.taskAsociation.length) {
      for (const association of this.taskAsociation) {
        if (association.alias && association.alias !== '') {
          associations.push({alias: association.alias});
        }
      }
    }
    this.listAliasAsocciations.emit(associations);
  }

  /**
   * Formatea la informacion de la tarea a guardar en la asociacion
   *
   * @private
   * @param {Tarea} task
   * @returns {*}
   * @memberof ManageAssociationComponent
   */
  private formatTaskAsociation(task: Tarea): any {
    if (task) {
      return {
        activo: task.activo,
        descripcion: task.descripcion,
        documentos: task.documentos,
        documentos_asociados: task['documentos_asociados'],
        id: task.id,
        nombre: task.nombre,
        orden: task.orden,
        tarea_actividad: task.tarea_actividad,
        tarea_estado: task.tarea_estado,
        tarea_tipo: task.tarea_tipo,
        tipo_asociacion: task['tipo_asociacion'],
        tramite: task['tramite'] ? task['tramite'] : null
      };
    } else {
      return {};
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/process-automation/manage-association/manage-association.component.ts